import * as process from 'process';

export const getBookingAdminToolConfig = async () => {
  try {
    const AdminToolGetApi: string = process.env.REACT_APP_GET_ADMIN_TOOL_API as string;
    const response = await fetch(AdminToolGetApi, { method: 'GET' });
    if (!response.ok) {
      throw new Error('Failed to fetch data. Please try again.');
    }
    return await response.json();
  } catch (error) {
    throw new Error('Failed to fetch data. Please try again.');
  }
};

export const getBookingReservationDetails = async (reservationId: string, pinNumber: string) => {
  try {
    const GetBookingReservationDetailsApi = process.env
      .REACT_APP_GET_RESERVATION_DETAILS_API as string;
    const response = await fetch(GetBookingReservationDetailsApi, {
      method: 'POST',
      body: JSON.stringify({
        reservationId: reservationId,
        pinCode: pinNumber
      })
    });
    return response.json();
  } catch (error) {
    return (error as Error).message;
  }
};
